import { render, staticRenderFns } from "./FooterSocial.vue?vue&type=template&id=34042c26&scoped=true&"
import script from "./FooterSocial.vue?vue&type=script&lang=ts&"
export * from "./FooterSocial.vue?vue&type=script&lang=ts&"
import style0 from "./FooterSocial.vue?vue&type=style&index=0&id=34042c26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34042c26",
  null
  
)

export default component.exports